/* eslint-disable react/jsx-key */
import React, { useContext } from "react";
import "./addDevice.css";
import { AddDeviceContext } from "../AddDeviceView";
import TopBar from "../../../components/TopBarComponent/Topbar";
import BackArrow from "../../../assets/images/Icons/backArrow.svg";
import { Container, Col, Row } from "react-bootstrap";
import TextInput from "../../../components/TextInputComponent/TextInput";
import AlertComponent from "../../../components/AlertComponent/AlertBox";
import Button from "../../../components/ButtonComponent/Button";
import dropDownData from "../../../constants/contentFile.json";
import DropDownItem from "../../../components/DropDownComponent/DropDown";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
const AddDevicePage = ({ textContants }) => {
  const {
    zone,
    setZone,
    activity,
    setActivity,
    ipAddress,
    setIpAdress,
    entryType,
    setEntryType,
    btnAddDeviceSave,
    editDeviceData,
    btnAddDeviceCancel,
    alert,
    getDeviceData,
    setAlert,
    navigateToListDevice,
    deviceList,
    requriedIpAdress,
    requriedEntyType,
    isEdit,
    activityRequired,
    setActivityRequired,
    zoneRequired,
    responseMessage,
    setZoneRequired,
    goBack,
    deviceId,
    devceinfomation,
    setIsEditor,
    isEditor,
  } = useContext(AddDeviceContext);

  const addOrEditDevice = () => {
    isEditor ? editDeviceData() : btnAddDeviceSave();
  };

  return (
    <div className="addDevice-page">
      <TopBar />
      <Container>
        <div className="heading-row my-3">
          <div className="addDeviceView">
            <div className="addDevice">
              {isEditor ? (
                <p className="profileEmpName">Edit Device</p>
              ) : (
                <p className="profileEmpName">Add New Device</p>
              )}
            </div>
            <div className="deviceItem">
              <Row>
                <Col lg={4}>
                  <Row>
                    <Col lg={3} className="paddingRight">
                      <label className="labelIpAddress">
                        {textContants.lblIpAddress}
                      </label>
                    </Col>
                    <Col lg={9}>
                      <div
                        className={
                          requriedIpAdress == true
                            ? "addDeviceFeildValueIpAdress addDevicefieldIpAdress"
                            : "addDeviceFeildValueIpAdress"
                        }
                      >
                        <TextInput
                          placeholder={ipAddress}
                          value={ipAddress}
                          type={"text"}
                          onChange={(e) => {
                            setIpAdress(e.target.value);
                          }}
                          onKeyDown={(event) => {
                            const keyCode = event.keyCode || event.which;
                            if (event.keyCode === 8) {
                              return;
                            }
                            const keyValue = event.key;
                            if (!/^[0-9.]$/.test(keyValue)) {
                              event.preventDefault();
                            }
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col lg={3} className="item-padding">
                      <label className="labelIpAddress">
                        {textContants.lblZone}
                      </label>
                    </Col>
                    <Col lg={9}>
                      <DropDownItem
                        selectedItem={zone}
                        setSelectedItem={setZone}
                        list={dropDownData.zoneData}
                        categoryRequired={zoneRequired}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col lg={4}>
                  <Row>
                    <Col lg={3}>
                      <label className="labelIpAddress">
                        {textContants.lblentryType}
                      </label>
                    </Col>
                    <Col lg={9}>
                      <div
                        className={
                          requriedEntyType == true
                            ? "addDeviceFeildValueIpAdress addDevicefieldIpAdress"
                            : "addDeviceFeildValueIpAdress"
                        }
                      >
                        <TextInput
                          placeholder={entryType}
                          value={entryType}
                          type={"text"}
                          onChange={(e) => {
                            setEntryType(e.target.value);
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col lg={4}>
                  <Row>
                    <Col lg={3}>
                      <label className="labelIpAddress">
                        {textContants.lblactivity}
                      </label>
                    </Col>
                    <Col lg={9}>
                      <DropDownItem
                        selectedItem={activity}
                        setSelectedItem={setActivity}
                        list={dropDownData.activityData}
                        categoryRequired={activityRequired}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>

            <div className="addDeviceButtonContainer">
              <div className="addDeviceButtonCancel">
                <Button
                  text={textContants.btnCancel}
                  onClick={() => {
                    goBack();
                  }}
                />
              </div>
              <div className="addDeviceButtonSave">
                <Button
                  text={textContants.btnSave}
                  onClick={() => {
                    addOrEditDevice();
                  }}
                />
              </div>
              {alert && (
                <AlertComponent
                  show={alert}
                  alertMessage={responseMessage}
                  handleSubmit={() => {
                    setAlert(false);
                    navigateToListDevice();
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
export default AddDevicePage;
